<template>
  <div class="default-template">
    <div class="default-template__ttl">{{ question.question }}</div>
    <div class="default-template__sub-ttl"></div>
    <div class="default-template__textarea">
      <textarea v-model="answerText"></textarea>
    </div>

    <div class="main__action">
      <button class="btn btn--grey" @click.prevent="back">Back</button>
      <button
        class="btn btn--grey"
        @click.prevent="next"
        v-if="question.canSkip"
      >
        Skip
      </button>
      <button class="btn" @click.prevent="next">Next</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "TextQuestion",
  props: {
    question: Object,
    answers: Object,
  },
  data() {
    return {
      answerText: "",
    };
  },
  watch: {
    question: {
      immediate: true,
      handler(val) {
        if (this.answers[val.id]) {
          this.answerText = this.answers[val.id].val;
        } else {
          this.answerText = "";
        }
      },
    },
  },
  methods: {
    next() {
      if (this.answerText === "" && !this.question.canSkip) return;
      const answer = {
        id: this.question.id,
        val: this.answerText,
        ttl: this.question.question,
      };
      this.answerText = "";
      this.$emit("next", answer);
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>
